import { identityApiClient } from '@/client/ApiClient';

export const logout = async () => {
  void (await identityApiClient.post('/api/v1/auth/logout'));
};

export * as identityApi from './';
